export const PIN_CATA = {
  ARTICLE: 'ARTICLE',
  SECTION: 'SECTION',
};

export const PIN_CATA_OPTIONS = [
  {
    id: PIN_CATA.ARTICLE,
    name: 'Article',
  },
  {
    id: PIN_CATA.SECTION,
    name: 'Section',
  },
];

export const PIN_TAB = {
  ALL: 'ALL',
  FEED: 'FEED',
  VIDEO_SHORT: 'VIDEO_SHORT',
};

export const PIN_TAB_OPTIONS = [
  {
    id: PIN_TAB.ALL,
    name: 'All',
  },
  {
    id: PIN_TAB.FEED,
    name: 'Bài viết',
  },
  {
    id: PIN_TAB.VIDEO_SHORT,
    name: 'Video',
  },
];

export const PIN_TAB_OPTIONS_SELECT = [
  {
    id: PIN_TAB.ALL,
    name: 'Tab All',
  },
  {
    id: PIN_TAB.FEED,
    name: 'Tab Bài viết',
  },
  {
    id: PIN_TAB.VIDEO_SHORT,
    name: 'Tab Video',
  },
];

export const PIN_STATUS = [
  {
    id: 'true',
    name: 'Hiển thị',
  },
  {
    id: 'false',
    name: 'Không hiển thị',
  },
  {
    id: 'expire',
    name: 'Hết hạn',
  },
];
